import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import parse from 'html-react-parser';

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqPOST, reqPUT, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { companycode } from "../../../../Hosts";

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const dados = useRef(null);
    const doc_type = useRef(null);

    const entities_list = useRef(null);

    const indicator_list = useRef(null);
    const indicator_active = useRef(null);
    const new_year = useRef(null);

    const year_active = useRef(null);
    const years_actives = useRef(null);
    const type_active = useRef(null);
    const types_actives = useRef(null);
        
    const audit_types = useRef(null);
    const new_row = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const [refresh, setRefresh] = useState(0);

    const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.info.tag.toUpperCase(); // ignore upper and lowercase
			const nameB = b.info.tag.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

    const order_array_name = (array) => {

        return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

    const order_array_year = (array) => {

		return array.sort((a, b) => {
			const nameA = a.toUpperCase(); // ignore upper and lowercase
			const nameB = b.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

    const fetch_entities_list = async (id) => {

        let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
        let result = []
        if (res.data !== undefined) {
            result = res.data.filter(el => parseInt(el.entity_type) === parseInt(id))
        }

        return result

    }

    const get_info = async () => {

        let res_1 = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/doc_type`)
        set_dados(doc_type.current = res_1.data)

        let res = await reqGET(`${api_crud_base}/intranet/quality/type/${getTokenInfo().companycode}/document`)

        if(res.data !== undefined && Array.isArray(res.data)) {

    		let res_ordenado = order_array(res.data)

            setData(res_ordenado) 
            set_dados(dados.current = res_ordenado) 

            let array_ano_aux = []
            for await (let el of res.data) {
                let aux_2 = array_ano_aux.filter(e1 => parseInt(e1) === parseInt(el.info.responsable.aproval.notification.split('-')[0]))
                if(Array.isArray(aux_2) && aux_2.length === 0) {
                    if((parseInt(el.info.settings.doc_type) === parseInt(6)) || (parseInt(el.info.settings.doc_type) === parseInt(34)) || (parseInt(el.info.settings.doc_type) === parseInt(35))) {
                        if(!isNaN(parseInt(el.info.responsable.aproval.notification.split('-')[0]))) {
                            array_ano_aux.push(el.info.responsable.aproval.notification.split('-')[0])
                        }
                    }
                }
            }

            set_dados(years_actives.current = order_array_year(array_ano_aux))
            set_dados(year_active.current = years_actives.current[years_actives.current.length - 1])

            change_year(years_actives.current[years_actives.current.length - 1])

        }

        let res_6 = await fetch_entities_list('1')
        if (res_6.length > 0) {
            res_6 = order_array_name(res_6)

            let res_aux_6 = []
            for await (let el of res_6) {
                res_aux_6.push({
                    id: el.id,
                    label: el.name,
                    email: el.email
                })
            }
            set_dados(entities_list.current = res_aux_6)
        }

    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            set_dados(year_active.current = '')

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const get_state = (element) => {

        let result = '<span className="badge rounded-0 bg-light text-dark p-3 fs-6">' + language[lang].action_not_open + '</span>'

        if(element?.info?.action?.analysis?.ac_am !== undefined) {

            if(element.info.action.analysis.ac_am === true) {

                if(element?.info?.action?.results?.responsable?.execution !== undefined && element?.info?.action?.results?.responsable?.execution !== null && element.info.action.results.responsable.execution !== '') {
                    if(element?.info?.action?.results?.value !== undefined && parseInt(element.info.action.results.value) === 1) {
                        result = '<span className="badge rounded-0 bg-success p-3 fs-6">' + language[lang].effective + '</span>'
                    }
                    else if(element?.info?.action?.results?.value !== undefined && element?.info?.action?.results?.value !== null && parseInt(element.info.action.results.value) === 0) {
                        result = '<span className="badge rounded-0 bg-danger p-3 fs-6">' + language[lang].not_effective + '</span>'
                    }
                }
                else if(element?.info?.action?.improvement?.responsable?.execution !== undefined && element?.info?.action?.improvement?.responsable?.execution !== null && element.info.action.improvement.responsable.execution !== '') {
                    result = '<span className="badge rounded-0 bg-warning text-dark p-3 fs-6">' + language[lang].for_evaluating + '</span>'
                }
                else {
                    result = '<span className="badge rounded-0 bg-orange text-dark p-3 fs-6">' + language[lang].action_to_be_taken + '</span>'
                }

            }
        }

        return result
    }
    
    const columns = [
        {
            name: language[lang].field_number,
            selector: 'info.number',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_type,
            selector: 'info.settings.occurrence_type',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_date,
            selector: 'info.action.identification.notification',
            cell: row => (
                row?.info?.action?.identification?.responsable?.notification !== undefined && row.info.action.identification.responsable.notification !== '' ? row.info.action.identification.responsable.notification.split('T')[0] : ''
            ),
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_name,
            selector: 'info.name',
            width: '45% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_state,
            cell: row => (
                parse(get_state(row))
            ),
            width: '15% !important',
            minWidth: '200px !important',
            sortable: true,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '150px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                        Array.isArray(row.info.file.pdf) && row.info.file.pdf.length > 0 ?
                            <a className="button button-update button-view p-0 pe-2" href={row.info.file.pdf[row.info.file.pdf.length - 1].link} target='_blank'>
                                <i className="bi bi-eye"></i>
                            </a>
                            :
                            null
                    }

                    {
                        permissions.current !== null && permissions.current.edit ?
                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                            :
                            null
                    }

                    {
                        permissions.current !== null && permissions.current.remove ?
                            <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                                <i className="bi bi-trash"></i>
                            </button>
                            :
                            null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const add_new_year = async () => {
  
        
        
        if(years_actives.current !== undefined && years_actives.current !== null && years_actives.current.length > 0) {

            let last_year = years_actives.current[years_actives.current.length - 1]
            let aux_year = parseInt(last_year.info.name) + 1
            set_dados(new_year.current = aux_year)
            set_dados(year_active.current = aux_year)

            set_dados(years_actives.current.push({
                id: '',
                info: {
                    name: aux_year
                }
            }))

            change_year(aux_year)

        }
        else {
            let aux_year = new Date().getFullYear()
            set_dados(new_year.current = aux_year)
            set_dados(year_active.current = aux_year)

            let aux = {
                id: '',
                info: {
                name: aux_year
            }
            }

            set_dados(years_actives.current = [aux])

            change_year(aux_year)
        }
    }

    const change_year = async (year) => {

        let res_aux = []
        for await (let el of dados.current) {

            if(el?.info?.responsable?.aproval?.notification !== undefined && el.info.responsable.aproval.notification.includes(year)) {
                res_aux.push(el)
            }

        }
        set_dados(indicator_active.current = res_aux)
    }


    const add_row = async (element) => {

        if(!Array.isArray(element.info.monitoring)) {
            element.info.monitoring = []
        }

        element.info.monitoring.push({
            id: Date.now()
        })

        await reqPUT(api_crud_route, element)

		setRefresh(r => r + 1)

    }

    const remove_row = async (id, element) => {

        console.log('id', id)
        console.log('element', element)

		let aux = []
		element.info.monitoring.forEach((el) => {
			if(parseInt(el.id) !== parseInt(id)) {
				aux.push(el)
			}
		})

		set_dados(element.info.monitoring = aux)

        await reqPUT(api_crud_route, element)
		console.log('aux', aux)


		setRefresh(r => r + 1)


    }

	const change_settings = (e) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset
		
		if (new_row.current === undefined) {
			new_row.current = []
		}

		new_row.current.forEach(el => {
			if(parseInt(el.id) === parseInt(id)) {
                el[name] = value
			}
		})

		set_dados(new_row.current, )

		setRefresh(r => r + 1)

		console.log('new_row.current', new_row.current)

	}

    const save_row = async () => {

        if(indicator_active.current.info.settings === undefined || indicator_active.current.info.settings) {
            indicator_active.current.info.settings = []
        }

        indicator_active.current.info.settings.push(new_row.current[0])

        if(indicator_active.current.id === '') {
            await reqPOST(api_crud_route, indicator_active.current)
        }
        else {
            await reqPUT(api_crud_route, indicator_active.current)
        }

    }

    const change_audit_monitoring_values = async (e, el) => {
		const { name, value, dataset } = e.target;
		const { id, order } = dataset

        console.log('el', el)
        console.log('name', name)
        console.log('value', value)
        console.log('id', id)
        console.log('order', order)

        if(el.info.monitoring === undefined || el.info.monitoring === null) {
            el.info.monitoring = []
        }

        if(name === 'responsable') {
            
            // el.info.monitoring.forEach(el => {
            for await (let el_m of el.info.monitoring) {
                if(parseInt(el_m.id) === parseInt(id)) {

                    if(el_m.responsable_ === undefined || el_m.responsable_ === null) {
                        el_m.responsable_ = []
                    }

                    let aux_ent = entities_list.current.find(e_ => parseInt(e_.id) === parseInt(value))
                    let aux_ent_2 = await reqGET(`${api_crud_base}/entities/photo/${getTokenInfo().companycode}/${aux_ent.id}`);
                    let aux_el = {
                        id: aux_ent.id,
                        name: aux_ent.label,
                        email: aux_ent?.email || '',
                        tag: aux_ent_2?.data?.tag || ''
                    }
                    if(el_m.responsable_[order] !== undefined && el_m.responsable_[order] !== null) {
                        el_m.responsable_[order] = aux_el
                    }
                    else {
                        el_m.responsable_.push(aux_el)
                    }

                }
            }
            // })

        }
        else {

            el.info.monitoring.forEach(el => {
                if(parseInt(el.id) === parseInt(id)) {
                    el[name] = value
                }
            })

        }

        console.log('el.info.monitoring', el.info.monitoring)

        await reqPUT(api_crud_route, el)

        setRefresh(r => r + 1)

    }

    const add_audit_monitoring_row_entities = async (el, m_id) => {

        for await (let el_m of el.info.monitoring) {
            if(parseInt(el_m.id) === parseInt(m_id)) {

                if(el_m.responsable_ === undefined || el_m.responsable_ === null) {
                    el_m.responsable_ = []
                }

                el_m.responsable_.push({id: '0'})

            }
        }

        await reqPUT(api_crud_route, el)

        setRefresh(r => r + 1)


    }

    const remove_audit_monitoring_row_entities = async (id, el, m_id, order) => {

        for await (let el_m of el.info.monitoring) {
            if(parseInt(el_m.id) === parseInt(m_id)) {

                let aux = el_m.responsable_.filter(e => parseInt(e.id) !== parseInt(id))
                el_m.responsable_ = aux

            }
        }

        await reqPUT(api_crud_route, el)

        setRefresh(r => r + 1)

    }

    return (isloading ?

        <Loader />

    :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container-fluid">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8">
                                    </div>
                                    <div className="table-body">
 
                                        <div className="row">

                                            <div className="col-12 mb-3">
                                                {
                                                years_actives.current !== undefined && years_actives.current !== null && Array.isArray(years_actives.current) && years_actives.current.length > 0 ?
                                                    <div className="row">
                                                        <div className="col-10 mb-3 d-flex">
                                                            {
                                                            years_actives.current.map((dt_el, dt_key) => {
                                                                return (
                                                                    <div key={dt_key}>
                                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el) === parseInt(year_active.current) ? ' active' : '' )} onClick={() => change_year(dt_el)} >{parseInt(dt_el)}</button>
                                                                    </div>
                                                                )
                                                            })
                                                            }
                                                        </div>
                                                    </div>
                                                :
                                                    null
                                                }
                                                {
                                                indicator_active?.current !== undefined && indicator_active?.current !== null ?
                                                    doc_type.current.map((el_dt, key_dt) => {
                                                        if((parseInt(el_dt.id) === parseInt(6)) || (parseInt(el_dt.id) === parseInt(34)) || (parseInt(el_dt.id) === parseInt(35))) {
                                                            return (
                                                                indicator_active?.current?.filter(e => parseInt(e.info.settings.doc_type) === parseInt(el_dt.id)).length > 0 ?
                                                                    <div key={key_dt} className="mb-5">                                                                            
                                                                        <div className="div-table">
                                                                            <div className="table-body table-responsive">

                                                                                <table className="table monitoring-list table-hover table-bordered align-middle">
                                                                                    <thead className="text-center align-middle">
                                                                                        <tr>
                                                                                            <th rowSpan={2} className="text-uppercase p-3">
                                                                                                {parse(el_dt.info.name.trim().replace(' ', '<br />'))}
                                                                                            </th>
                                                                                            <th rowSpan={2} className="p-3" style={{minWidth: '250px'}}>{language[lang].field_responsable}</th>
                                                                                            <th rowSpan={2} className="p-3">{language[lang].field_indicator}</th>
                                                                                            <th rowSpan={2} className="p-3">{parse(language[lang].field_result_last_year)}</th>
                                                                                            <th rowSpan={2} className="p-3">{parse(language[lang].field_final_goal)}</th>
                                                                                            <th rowSpan={2} className="p-3">{language[lang].field_actions}</th>
                                                                                            <th rowSpan={2} className="p-3">{language[lang].field_ver}</th>
                                                                                            <th colSpan={12} className="p-3">{language[lang].field_followup}</th>
                                                                                            <th rowSpan={2} className="p-3">{parse(language[lang].field_final_result)}</th>
                                                                                            <th rowSpan={2} className="p-3 text-nowrap">{language[lang].field_c_nc}</th>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th className="p-3">
                                                                                                J
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                F
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                M
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                A
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                M
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                J
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                J
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                A
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                S
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                O
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                N
                                                                                            </th>
                                                                                            <th className="p-3">
                                                                                                D
                                                                                            </th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                        indicator_active?.current?.filter(e => parseInt(e.info.settings.doc_type) === parseInt(el_dt.id)).map((el, key) => {
                                                                                            return (
                                                                                                el.info.monitoring !== undefined && el.info.monitoring !== null && Array.isArray(el.info.monitoring) && el.info.monitoring.length > 0 ?
                                                                                                    el.info.monitoring.map((el_m, key_m) => {
                                                                                                        return (
                                                                                                            <tr key={key_m}>   
                                                                                                                <td className={key_m % 2 === 0 ? "bg-white" : "bg-light"}>
                                                                                                                    <div className="d-flex justify-content-between align-items-center" style={{width: '150px'}}>
                                                                                                                        <p>
                                                                                                                            {el.info.tag} - {el.info.name}
                                                                                                                        </p>
                                                                                                                        <div className="d-flex flex-column">
                                                                                                                            <button type="button" className='btn btn-sm btn-secondary rounded-0' onClick={() => add_row(el)}><i className="bi bi-plus"></i></button>
                                                                                                                            <button type="button" className='btn btn-sm btn-secondary rounded-0 mt-1' onClick={() => remove_row(el_m.id, el)}><i className="bi bi-x"></i></button>
                                                                                                                        </div>
                                                                                                                    </div>                                                                                                        
                                                                                                                </td>
                                                                                                                <td className="text-center">
                                                                                                                    {
                                                                                                                    (el_m.responsable_ !== undefined && el_m.responsable_ !== null && el_m.responsable_.length > 0) ?
                                                                                                                        el_m.responsable_.map((el_r, k_r) => {
                                                                                                                            return (
                                                                                                                                <div key={k_r} className="input-group mb-1">
                                                                                                                                    <select
                                                                                                                                        name="responsable"
                                                                                                                                        data-id={el_m.id}
                                                                                                                                        data-order={k_r}
                                                                                                                                        className="form-select form-control rounded-0"
                                                                                                                                        onChange={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                                        value={el_r?.id !== undefined && el_r?.id !== null ? el_r.id : ''}
                                                                                                                                    >
                                                                                                                                        <option value="">{language[lang].field_choose}</option>
                                                                                                                                        {
                                                                                                                                        entities_list.current !== undefined && entities_list.current !== null ?
                                                                                                                                            entities_list.current.map((el_el, k_el) => (
                                                                                                                                                <option key={k_el} value={el_el.id}>
                                                                                                                                                    {el_el.label}
                                                                                                                                                </option>
                                                                                                                                            ))
                                                                                                                                        :
                                                                                                                                            null
                                                                                                                                        }
                                                                                                                                    </select>
                                                                                                                                    <button className="btn btn-secondary rounded-0" type="button" onClick={() => remove_audit_monitoring_row_entities(el_r.id, el, el_m.id, k_r)}><i className="bi bi-x-lg"></i></button>
                                                                                                                                    <button className={"btn btn-secondary rounded-0 ms-1" + (k_r === 0 ? ' visible' : ' invisible')} type="button" onClick={() => add_audit_monitoring_row_entities(el, el_m.id)}><i className="bi bi-plus-lg"></i></button>
                                                                                                                                </div>
                                                                                                                            )
                                                                                                                        })
                                                                                                                    :                                                                                                                            
                                                                                                                        <div className="input-group">
                                                                                                                            <select
                                                                                                                                name="responsable"
                                                                                                                                data-id={el_m.id}
                                                                                                                                className="form-select form-control rounded-0"
                                                                                                                                onChange={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                                value={el_m?.trainee?.id !== undefined && el_m?.trainee?.id !== null ? el_m.trainee.id : ''}
                                                                                                                            >
                                                                                                                                <option value="">{language[lang].field_choose}</option>
                                                                                                                                {
                                                                                                                                entities_list.current !== undefined && entities_list.current !== null ?
                                                                                                                                    entities_list.current.map((el_el, k_el) => (
                                                                                                                                        <option key={k_el} value={el_el.id}>
                                                                                                                                            {el_el.label}
                                                                                                                                        </option>
                                                                                                                                    ))
                                                                                                                                :
                                                                                                                                    null
                                                                                                                                }
                                                                                                                            </select>
                                                                                                                            <button className="btn btn-secondary rounded-0" type="button" onClick={() => remove_audit_monitoring_row_entities(0, el, el_m.id, 0)}><i className="bi bi-x-lg"></i></button>
                                                                                                                            <button className={"btn btn-secondary rounded-0 ms-1 invisible"} type="button"><i className="bi bi-plus-lg"></i></button>
                                                                                                                        </div>
                                                                                                                    }
                                                                                                                    <textarea
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 d-none" 
                                                                                                                        style={{width: '150px'}}
                                                                                                                        name="responsable" 
                                                                                                                        defaultValue={el_m.responsable !== undefined && el_m.responsable !== null ? el_m.responsable : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <textarea
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0" 
                                                                                                                        style={{width: '400px'}}
                                                                                                                        rows='3'
                                                                                                                        name="indicator" 
                                                                                                                        defaultValue={el_m.indicator !== undefined && el_m.indicator !== null ? el_m.indicator : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '100px'}}
                                                                                                                        name="result_last_year" 
                                                                                                                        defaultValue={el_m.result_last_year !== undefined && el_m.result_last_year !== null ? el_m.result_last_year : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <div className="input-group" style={{width: '150px'}}>
                                                                                                                        <select
                                                                                                                            name="obj_signal"
                                                                                                                            className="form-select form-control text-center mb-4 mb-lg-0 rounded-0"
                                                                                                                            style={{width: '50px'}}
                                                                                                                            defaultValue={el_m.obj_signal !== undefined && el_m.obj_signal !== null ? el_m.obj_signal : ''}
                                                                                                                            data-id={el_m.id}
                                                                                                                            onChange={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                        >
                                                                                                                            <option value="=">{'='}</option>
                                                                                                                            <option value=">=">{'>='}</option>
                                                                                                                            <option value="<=">{'<='}</option>
                                                                                                                        </select>
                                                                                                                        <input
                                                                                                                            type="text" 
                                                                                                                            className="form-control rounded-0 text-end" 
                                                                                                                            style={{width: '50px'}}
                                                                                                                            name="obj_value" 
                                                                                                                            defaultValue={el_m.obj_value !== undefined && el_m.obj_value !== null ? el_m.obj_value : ''}
                                                                                                                            data-id={el_m.id}
                                                                                                                            onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <textarea
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0" 
                                                                                                                        style={{width: '400px'}}
                                                                                                                        rows='3'
                                                                                                                        name="actions" 
                                                                                                                        defaultValue={el_m.actions !== undefined && el_m.actions !== null ? el_m.actions : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0" 
                                                                                                                        style={{width: '100px'}}
                                                                                                                        name="ver" 
                                                                                                                        defaultValue={el_m.ver !== undefined && el_m.ver !== null ? el_m.ver : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_jan" 
                                                                                                                        defaultValue={el_m.month_jan !== undefined && el_m.month_jan !== null ? el_m.month_jan : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_feb" 
                                                                                                                        defaultValue={el_m.month_feb !== undefined && el_m.month_feb !== null ? el_m.month_feb : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_mar" 
                                                                                                                        defaultValue={el_m.month_mar !== undefined && el_m.month_mar !== null ? el_m.month_mar : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_apr" 
                                                                                                                        defaultValue={el_m.month_apr !== undefined && el_m.month_apr !== null ? el_m.month_apr : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_may" 
                                                                                                                        defaultValue={el_m.month_may !== undefined && el_m.month_may !== null ? el_m.month_may : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_jun" 
                                                                                                                        defaultValue={el_m.month_jun !== undefined && el_m.month_jun !== null ? el_m.month_jun : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_jul" 
                                                                                                                        defaultValue={el_m.month_jul !== undefined && el_m.month_jul !== null ? el_m.month_jul : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_aug" 
                                                                                                                        defaultValue={el_m.month_aug !== undefined && el_m.month_aug !== null ? el_m.month_aug : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_sep" 
                                                                                                                        defaultValue={el_m.month_sep !== undefined && el_m.month_sep !== null ? el_m.month_sep : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_oct" 
                                                                                                                        defaultValue={el_m.month_oct !== undefined && el_m.month_oct !== null ? el_m.month_oct : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_nov" 
                                                                                                                        defaultValue={el_m.month_nov !== undefined && el_m.month_nov !== null ? el_m.month_nov : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td className="py-0">
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 text-end" 
                                                                                                                        style={{width: '80px'}}
                                                                                                                        name="month_dec" 
                                                                                                                        defaultValue={el_m.month_dec !== undefined && el_m.month_dec !== null ? el_m.month_dec : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)} 
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0" 
                                                                                                                        style={{width: '100px'}}
                                                                                                                        name="result_final" 
                                                                                                                        defaultValue={el_m.result_final !== undefined && el_m.result_final !== null ? el_m.result_final : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <select
                                                                                                                        name="c_nc"
                                                                                                                        className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                                                        style={{minWidth: '100px'}}
                                                                                                                        value={el_m.c_nc !== undefined && el_m.c_nc !== null ? el_m.c_nc : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onChange={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    >
                                                                                                                    <option value="">{language[lang].field_choose}</option>
                                                                                                                    <option value="C">C</option>
                                                                                                                    <option value="NC">NC</option>
                                                                                                                </select>
                                                                                                                    <input
                                                                                                                        type="text" 
                                                                                                                        className="form-control rounded-0 d-none" 
                                                                                                                        style={{width: '50px'}}
                                                                                                                        name="c_nc" 
                                                                                                                        value={el_m.c_nc !== undefined && el_m.c_nc !== null ? el_m.c_nc : ''}
                                                                                                                        data-id={el_m.id}
                                                                                                                        onBlur={(e) => change_audit_monitoring_values(e, el)}
                                                                                                                    />
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        )

                                                                                                    })
                                                                                                :
                                                                                                    <tr>   
                                                                                                        <td className={"bg-white"}>
                                                                                                            <div className="d-flex justify-content-between align-items-center" style={{width: '150px'}}>
                                                                                                                <p>
                                                                                                                    {el.info.tag} - {el.info.name}
                                                                                                                </p>
                                                                                                                <button type="button" className='btn btn-sm btn-secondary rounded-0' onClick={() => add_row(el)}><i className="bi bi-plus-lg"></i></button>
                                                                                                            </div>                                                                                                        
                                                                                                        </td>
                                                                                                        <td  colSpan={20}></td>
                                                                                                    </tr>
                                                                                            )
                                                                                        })
                                                                                        }
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                :
                                                                    null
                                                            )
                                                        }
                                                        else {
                                                           return null;
                                                        }
                                                    })
                                                :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}